<template>
  <iframe
          :src="`${url}?mls=1`"
          allowfullscreen
          allow="vr;accelerometer;gyroscope;fullscreen">
  </iframe>
</template>

<script>
  export default {
    props: {
      url: {
        default: '',
        type: String
      }
    }
  }
</script>
